import i18n from '~/components/i18n';
import { milkPaymentStatus } from '../Invoice/constants';

export const getTableColumnHeaders = () => [
  {
    name: i18n.t('Supp. no.'),
    key: 'supplierNo',
    sorted: 'asc'
  },
  {
    name: i18n.t('Supplier'),
    key: 'companyName'
  },
  {
    name: i18n.t('Total amount (in kg)'),
    key: 'amountInKg',
    type: 'no-unit-number',
    decimalScale: 0
  },
  {
    name: i18n.t('Milk price net (in €)'),
    key: 'netTotal',
    type: 'no-unit-number'
  },
  {
    name: i18n.t('Price (in € Ct/kg)'),
    key: 'price',
    type: 'no-unit-number'
  },
  {
    name: i18n.t('Verified?'),
    key: 'hasErrors',
    type: 'invoice-errors'
  },
  {
    name: i18n.t('Payout amount (in €)'),
    key: 'total',
    type: 'no-unit-number'
  },
  {
    name: i18n.t('Actions')
  }
]

export const getSteps = () => [
  {
    title: i18n.t('Start process'),
    titleAfterFinished: i18n.t('Process started successfully'),
    description: 'Bitte klicken Sie auf den Button “MG-Nachzahlung generieren“, um den Prozess zu starten.',
    statusValue: milkPaymentStatus.defaultStatus
  },
  {
    title: 'Milchgeld Nachzahlungen erstellt',
    titleAfterFinished: i18n.t('MGA created successfully'),
    description: 'Bitte haben Sie ein wenig Geduld, die Milchgeld Nachzahlungen werden derzeit erstellt',
    statusValue: milkPaymentStatus.generatingStatus
  },
  {
    title: 'MG-Nachzahlung verifiziert',
    titleAfterFinished: 'Bitte prüfen Sie die einzelnen Milchgeld Nachzahlungen inkl. Ausdruck bevor Sie mit der Erstellung der SEPA XML fortfahren.',
    description: i18n.t('Please check the individual milk payment statements including the printout before continuing to create the SEPA XML.'),
    statusValue: milkPaymentStatus.verificationStatus
  },
  {
    title: i18n.t('SEPA XML'),
    titleAfterFinished: 'Prüfen und Importieren Sie die SEPA XML in Ihr Bankprogramm und schliessen Sie danach die Milchgeld Nachzahlung ab.',
    description: i18n.t('Check and import the SEPA XML into your banking program and then close the billing month.'),
    statusValue: milkPaymentStatus.preclosingStatus
  },
  {
    title: 'MG-Nachzahlung abgeschlossen',
    titleAfterFinished: i18n.t('MGA successfully completed'),
    description: i18n.t(''),
    statusValue: milkPaymentStatus.closedStatus
  }
]